<template>
	<v-row class="pb-offset ma-0">
        <v-container fluid class="pa-0 pb-offset pa-0">
            <!-- Card unica impostazioni -->
            <v-card class="round-card background-2">
                <v-card-title class="pa-3">
                    <v-icon left color="success">mdi-whatsapp</v-icon>
                    <span>Risposte Automatiche WhatsApp</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-4">
                    <!-- Switch attivazione -->
                    <v-row class="ma-0">
                        <v-col cols="12" class="py-0">
                            <v-switch
                                inset
                                class="text-center"
                                label="Attiva risposte automatiche"
                                v-model="enabled"
                                color="primary"
                            ></v-switch>
                        </v-col>
                    </v-row>

                    <template v-if="enabled">
                        <!-- Modalita sempre attivo o schedulato -->
                        <v-row class="ma-0 mt-2">
                            <v-col cols="12" class="py-0">
                                <v-radio-group v-model="settings.always_active" row>
                                    <v-radio
                                        label="Sempre attivo"
                                        :value="true"
                                    ></v-radio>
                                    <v-radio
                                        label="Solo in determinati orari"
                                        :value="false"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>

                        <!-- Configurazione orari -->
                        <template v-if="!settings.always_active">
                            <v-subheader class="pl-0">Orari di attivazione</v-subheader>
                            <v-row>
                                <v-col
                                    v-for="(day, key) in days"
                                    :key="key"
                                    cols="12"
                                    sm="6"
                                    md="4"
                                >
                                    <v-card outlined class="pa-3">
                                        <v-switch
                                            inset
                                            :label="day.label"
                                            v-model="schedule[key].enabled"
                                            color="primary"
                                            class="mt-0 mb-0"
                                            hide-details
                                        ></v-switch>
                                        <v-row v-if="schedule[key].enabled" class="mt-3 mx-0">
                                            <v-col cols="6" class="pl-0 pr-1 py-3">
                                                <v-text-field
                                                    v-model="schedule[key].start"
                                                    label="Dalle"
                                                    type="time"
                                                    outlined
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6" class="pl-1 pr-0 py-3">
                                                <v-text-field
                                                    v-model="schedule[key].end"
                                                    label="Alle"
                                                    type="time"
                                                    outlined
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>

                        <!-- Sezione messaggi -->
                        <v-divider class="my-4"></v-divider>
                        <v-subheader class="pl-0">Sequenza Messaggi</v-subheader>

                        <p class="text--secondary mb-4" v-if="messages.length === 0">
                            Nessun messaggio configurato. Aggiungi almeno un messaggio per attivare le risposte automatiche.
                        </p>

                        <draggable
                            v-model="messages"
                            :options="{
                                animation: 350,
                                ghostClass: 'ghost',
                                chosenClass: 'chosen',
                                handle: '.drag-handle'
                            }"
                            @end="updateStepOrder"
                        >
                            <v-card
                                v-for="(msg, index) in messages"
                                :key="index"
                                outlined
                                class="mb-3 pa-3"
                            >
                                <v-row align="center">
                                    <v-col cols="auto" class="py-0">
                                        <v-icon class="drag-handle" style="cursor: grab">mdi-drag</v-icon>
                                    </v-col>
                                    <v-col cols="auto" class="py-4">
                                        <v-avatar color="primary" size="26">
                                            <span class="white--text">{{ msg.step_order }}</span>
                                        </v-avatar>
                                    </v-col>
                                    <v-col class="py-0">
                                        <strong>Step {{ msg.step_order }}</strong>
                                        <span class="text--secondary ml-2">
                                            Dopo {{ formatDelay(msg.delay_minutes) }}
                                        </span>
                                    </v-col>
                                    <v-col cols="auto" class="pa-4">
                                        <v-btn icon @click="editMessage(index)">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn icon color="error" @click="removeMessage(index)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <div class="text--secondary message-preview pa-4 pt-0 mt-2 pb-6">
                                    {{ msg.message_text }}
                                </div>
                            </v-card>
                        </draggable>
                        <v-row class="ma-0">
                            <v-spacer></v-spacer>
    
                            <v-btn
                                color="primary"
                                @click="addMessage"
                                class="mt-2"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Aggiungi Messaggio
                            </v-btn>
                        </v-row>
                    </template>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        :loading="saving"
                        @click="saveSettings"
                    >
                        Salva
                    </v-btn>
                </v-card-actions>
            </v-card>

            <!-- Card informativa -->
            <v-card class="round-card background-2 mt-4">
                <v-card-title class="pa-3">
                    <v-icon left color="info">mdi-information-outline</v-icon>
                    <span>Come funzionano le Risposte Automatiche</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-4">
                    <!-- Concetto base -->
                    <div class="info-section mb-4">
                        <h4 class="subtitle-1 font-weight-bold mb-2">
                            <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                            La finestra delle 24 ore
                        </h4>
                        <p class="text--secondary mb-0">
                            WhatsApp Business consente di inviare messaggi liberi solo entro <strong>24 ore</strong> dall'ultimo messaggio ricevuto dal cliente.
                            Dopo questo periodo, per contattare il cliente e necessario utilizzare un <strong>template a pagamento</strong>.
                            Le risposte automatiche ti aiutano a mantenere aperta questa finestra anche quando non sei disponibile.
                        </p>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <!-- Come funziona -->
                    <div class="info-section mb-4">
                        <h4 class="subtitle-1 font-weight-bold mb-2">
                            <v-icon small color="primary" class="mr-1">mdi-cog-outline</v-icon>
                            Come funziona il sistema
                        </h4>
                        <ul class="text--secondary pl-4">
                            <li class="mb-2">Quando un cliente ti scrive e non rispondi, il sistema invia automaticamente i messaggi configurati in sequenza</li>
                            <li class="mb-2">Ogni messaggio viene inviato dopo il <strong>ritardo specificato</strong> dall'evento precedente</li>
                            <li class="mb-2">Se il cliente risponde, il flusso <strong>prosegue</strong> con il messaggio successivo (non riparte da capo)</li>
                            <li class="mb-2">Se rispondi manualmente alla conversazione, il flusso si <strong>interrompe</strong></li>
                            <li class="mb-2">Se dopo la tua risposta manuale il cliente scrive di nuovo, il flusso <strong>riparte dallo step 1</strong></li>
                            <li>Quando leggi o rispondi alla chat, la conversazione viene segnata come letta e il flusso si ferma</li>
                        </ul>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <!-- Strategia messaggi -->
                    <div class="info-section mb-4">
                        <h4 class="subtitle-1 font-weight-bold mb-2">
                            <v-icon small color="primary" class="mr-1">mdi-lightbulb-outline</v-icon>
                            Strategia per i messaggi
                        </h4>
                        <p class="text--secondary mb-2">
                            L'obiettivo principale è <strong>far rispondere il cliente</strong>. Ogni risposta del cliente rinnova la finestra di 24 ore,
                            permettendoti di continuare la conversazione senza costi aggiuntivi.
                        </p>
                        <v-alert type="info" text dense class="mb-0">
                            <strong>Suggerimento:</strong> Scrivi messaggi che invitino il cliente a rispondere con una domanda o una conferma.
                            Ad esempio: "Posso ricontattarti lunedi mattina?" oppure "Rispondimi 'ok' e ti richiamo appena possibile".
                        </v-alert>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <!-- Caso d'uso weekend -->
                    <div class="info-section mb-4">
                        <h4 class="subtitle-1 font-weight-bold mb-2">
                            <v-icon small color="primary" class="mr-1">mdi-calendar-weekend</v-icon>
                            Esempio: gestione del weekend
                        </h4>
                        <p class="text--secondary mb-2">
                            Un cliente ti scrive <strong>venerdi sera alle 20:00</strong>. Senza risposte automatiche,
                            lunedi mattina la finestra sarebbe scaduta e dovresti inviare un template.
                        </p>
                        <p class="text--secondary mb-2">
                            Con le risposte automatiche configurate correttamente:
                        </p>
                        <v-simple-table dense class="info-table mb-3">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Quando</th>
                                        <th>Cosa succede</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>Ven 20:00</strong></td>
                                        <td>Il cliente scrive</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Ven 20:30</strong></td>
                                        <td>Step 1: "Ciao! Al momento non sono disponibile, ti rispondo lunedi. Posso aiutarti con qualcosa di urgente?"</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Sab 10:00</strong></td>
                                        <td>Il cliente risponde "No, niente di urgente" <v-icon x-small color="success">mdi-arrow-right</v-icon> Finestra rinnovata!</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Sab 14:00</strong></td>
                                        <td>Step 2: "Perfetto! Ti ricontatto lunedi mattina. Rispondimi 'ok' cosi resto in contatto"</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Sab 15:00</strong></td>
                                        <td>Il cliente risponde "ok" <v-icon x-small color="success">mdi-arrow-right</v-icon> Finestra rinnovata fino a Dom 15:00!</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Dom 12:00</strong></td>
                                        <td>Step 3: "Ci vediamo domani! Scrivimi se hai domande nel frattempo"</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Dom 18:00</strong></td>
                                        <td>Il cliente risponde <v-icon x-small color="success">mdi-arrow-right</v-icon> Finestra rinnovata fino a Lun 18:00!</td>
                                    </tr>
                                    <tr class="success lighten-1">
                                        <td><strong>Lun 09:00</strong></td>
                                        <td><strong>Puoi rispondere liberamente senza usare template!</strong></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <!-- Consigli finali -->
                    <div class="info-section">
                        <h4 class="subtitle-1 font-weight-bold mb-2">
                            <v-icon small color="primary" class="mr-1">mdi-check-circle-outline</v-icon>
                            Consigli pratici
                        </h4>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-card outlined class="pa-3 fill-height">
                                    <div class="d-flex align-center mb-2">
                                        <v-icon color="success" small class="mr-2">mdi-thumb-up</v-icon>
                                        <strong class="success--text">Da fare</strong>
                                    </div>
                                    <ul class="text--secondary pl-4 mb-0">
                                        <li>Usa domande che richiedono risposta</li>
                                        <li>Indica quando sarai disponibile</li>
                                        <li>Chiedi conferme semplici ("rispondi ok")</li>
                                        <li>Distribuisci i messaggi nel tempo</li>
                                    </ul>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-card outlined class="pa-3 fill-height">
                                    <div class="d-flex align-center mb-2">
                                        <v-icon color="error" small class="mr-2">mdi-thumb-down</v-icon>
                                        <strong class="error--text">Da evitare</strong>
                                    </div>
                                    <ul class="text--secondary pl-4 mb-0">
                                        <li>Messaggi troppo lunghi o formali</li>
                                        <li>Troppi messaggi in poco tempo</li>
                                        <li>Messaggi che non richiedono risposta</li>
                                        <li>Toni impersonali o robotici</li>
                                    </ul>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>

            <!-- Dialog modifica messaggio -->
            <v-dialog v-model="messageDialog" max-width="800" persistent>
                <v-card class="background-2 round-card">
                    <v-card-title class="pa-3 background-1">
                        <p class="pl-2">
                            {{ editingIndex !== null ? 'Modifica Messaggio' : 'Nuovo Messaggio' }}
                        </p>
                    </v-card-title>
				    <v-divider></v-divider>
				    <v-card-text class="pa-6">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model.number="editingMessage.delay_minutes"
                                    label="Ritardo (minuti)"
                                    type="number"
                                    outlined
                                    dense
                                    min="1"
                                    hint="Tempo di attesa prima di inviare questo messaggio"
                                    persistent-hint
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="editingMessage.message_text"
                                    label="Testo del messaggio"
                                    outlined
                                    rows="6"
                                    counter
                                    hint="Il messaggio che verra inviato automaticamente"
                                    persistent-hint
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

				    <v-divider></v-divider>

				    <v-card-actions class="pa-3">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelMessageEdit">Annulla</v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="saveMessage"
                            :disabled="!editingMessage.message_text || !editingMessage.delay_minutes"
                        >
                            Salva
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-row>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
    name: 'whatsapp-auto-reply',

    components: {
        Draggable
    },

    data() {
        return {
            loading: true,
            saving: false,
            enabled: false,
            settings: {
                always_active: true
            },
            schedule: {
                monday: { enabled: false, start: '18:00', end: '09:00' },
                tuesday: { enabled: false, start: '18:00', end: '09:00' },
                wednesday: { enabled: false, start: '18:00', end: '09:00' },
                thursday: { enabled: false, start: '18:00', end: '09:00' },
                friday: { enabled: false, start: '18:00', end: '09:00' },
                saturday: { enabled: true, start: '00:00', end: '23:59' },
                sunday: { enabled: true, start: '00:00', end: '23:59' }
            },
            days: {
                monday: { label: 'Lunedi' },
                tuesday: { label: 'Martedi' },
                wednesday: { label: 'Mercoledi' },
                thursday: { label: 'Giovedi' },
                friday: { label: 'Venerdi' },
                saturday: { label: 'Sabato' },
                sunday: { label: 'Domenica' }
            },
            messages: [],
            messageDialog: false,
            editingIndex: null,
            editingMessage: {
                step_order: 1,
                message_text: '',
                delay_minutes: 30
            }
        }
    },

    methods: {
        loadSettings() {
            this.loading = true
            this.axios.get('whatsapp-auto-reply').then(response => {
                const data = response.data.data
                this.enabled = !data.barred
                this.settings.always_active = data.always_active

                if (data.schedule) {
                    Object.keys(data.schedule).forEach(day => {
                        if (this.schedule[day]) {
                            this.schedule[day] = data.schedule[day]
                        }
                    })
                }

                this.messages = data.messages || []
                this.loading = false
            }).catch(error => {
                this.$store.commit('setSnackbarError')
                this.loading = false
            })
        },

        saveSettings() {
            this.saving = true

            const payload = {
                barred: !this.enabled,
                always_active: this.settings.always_active,
                schedule: this.settings.always_active ? null : this.schedule,
                messages: this.messages.map((msg, index) => ({
                    id: msg.id || null,
                    step_order: index + 1,
                    message_text: msg.message_text,
                    delay_minutes: msg.delay_minutes
                }))
            }

            this.axios.post('whatsapp-auto-reply', payload).then(response => {
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Impostazioni salvate con successo',
                    value: true,
                    color: 'success'
                })
                this.saving = false

                // Ricarica per avere i nuovi ID
                this.loadSettings()
            }).catch(error => {
                this.$store.commit('setSnackbarError')
                this.saving = false
            })
        },

        addMessage() {
            this.editingIndex = null
            this.editingMessage = {
                step_order: this.messages.length + 1,
                message_text: '',
                delay_minutes: 30
            }
            this.messageDialog = true
        },

        editMessage(index) {
            this.editingIndex = index
            this.editingMessage = { ...this.messages[index] }
            this.messageDialog = true
        },

        saveMessage() {
            if (this.editingIndex !== null) {
                this.messages.splice(this.editingIndex, 1, { ...this.editingMessage })
            } else {
                this.messages.push({ ...this.editingMessage })
            }
            this.updateStepOrder()
            this.messageDialog = false
        },

        cancelMessageEdit() {
            this.messageDialog = false
            this.editingIndex = null
            this.editingMessage = {
                step_order: 1,
                message_text: '',
                delay_minutes: 30
            }
        },

        removeMessage(index) {
            this.messages.splice(index, 1)
            this.updateStepOrder()
        },

        updateStepOrder() {
            this.messages.forEach((msg, index) => {
                msg.step_order = index + 1
            })
        },

        formatDelay(minutes) {
            if (minutes < 60) {
                return `${minutes} minuti`
            } else if (minutes < 1440) {
                const hours = Math.floor(minutes / 60)
                const mins = minutes % 60
                return mins > 0 ? `${hours}h ${mins}m` : `${hours} ore`
            } else {
                const days = Math.floor(minutes / 1440)
                const hours = Math.floor((minutes % 1440) / 60)
                return hours > 0 ? `${days}g ${hours}h` : `${days} giorni`
            }
        },
    },

    created() {
        this.loadSettings()
        this.$store.commit('endProgress')
    }
}
</script>

<style scoped>
.drag-handle {
    cursor: grab;
}

.drag-handle:active {
    cursor: grabbing;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.chosen {
    background: #f0f0f0;
}

.message-preview {
    white-space: pre-line;
    background: rgba(0,0,0,0.03);
    border-radius: 4px;
}

.info-section h4 {
    display: flex;
    align-items: center;
}

.info-table {
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 4px;
}

.info-table th {
    background: rgba(0,0,0,0.04) !important;
}

.info-table td,
.info-table th {
    font-size: 0.875rem !important;
}
</style>
